export const accessorySystemType = (function () {
  const system = {
    'purchaser': 'purchaser_web',
    'supplier': 'supplier_web',
    'mall': 'mall_web',
    'inner': 'dev_sy_tenant_manager_web'
  }
  return system[window.fe.project] || 'purchaser_web'
})()
